<template>
  <div class="props-group">
    <el-form-item label="上传地址" prop="properties.requestUrl" :rules="rules">
      <el-input v-model="component.properties.requestUrl" placeholder="请输入上传地址"/>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-big-file-upload',
  props: ['component'],
  data () {
    return {
      rules: [
        { required: true, message: '请输入上传地址', trigger: 'blur' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/big-file-upload.vue